import { render, staticRenderFns } from "./KeyLiquidityRatioBlock.vue?vue&type=template&id=7197ac36&scoped=true"
import script from "./KeyLiquidityRatioBlock.vue?vue&type=script&lang=js"
export * from "./KeyLiquidityRatioBlock.vue?vue&type=script&lang=js"
import style0 from "./KeyLiquidityRatioBlock.vue?vue&type=style&index=0&id=7197ac36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7197ac36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VLazy,VRow})
